/**
 * Formats a UTC date string as a long date (e.g. "January 15, 2026" for en-US,
 * "15 January 2026" for en-AU).
 */
export function formatDateLong(dateString: string, locale: string): string {
  return new Intl.DateTimeFormat(locale, {
    year: 'numeric',
    month: 'long',
    day: 'numeric',
  }).format(new Date(dateString));
}
